import { Component, Input, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-invoice-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './invoice-modal.component.html',
  styleUrl: './invoice-modal.component.scss',
})
export class InvoiceModalComponent {
  @Input() id: string = '';
  @Input() patientRecordId: string = '';
  @Input() invoiceReportGenerated: boolean = false;
  @Output() downloadInvoiceEvent = new EventEmitter<void>();
  @Output() sendInvoiceEvent = new EventEmitter<void>();
  @Output() closeModalEvent = new EventEmitter<void>();

  constructor(private translate: TranslateService) {
    const userLang = localStorage.getItem('selectedLanguage') || 'en';
    this.translate.use(userLang);
  }

  downloadInvoice() {
    this.downloadInvoiceEvent.emit();
  }

  sendInvoice() {
    this.sendInvoiceEvent.emit();
  }

  closeModal() {
    this.closeModalEvent.emit();
  }
}
